import { z } from 'zod';
import { privateCidrRequiredSchema } from '#schemas/general/cidr.ts';

export const getStartedFormSchema = z.object({
  cidrV4: privateCidrRequiredSchema.or(z.literal('')).optional(),
});
